<script>
import baseMixin from '@/mixins/baseMixin'
import { StarRatingField } from '@/models/forms/fields/starRatingField'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionStarRatingField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: StarRatingField,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    hasStarRating() {
      return !!this.value && this.value !== 0
    },
    compStarRating() {
      if (!this.hasStarRating) return -1
      return this.value
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <v-rating
        v-if="hasStarRating"
        readonly
        half-increments
        hover
        :length="field.starCount"
        :value="value"
      ></v-rating>
    </InfoLabel>
  </div>
</template>
